var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v("Administrar organización"),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [_vm._v("Nueva área")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "notification is-warning" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Nombre")]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model.nombre,
                expression: "model.nombre",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required:true}",
              },
              { name: "autofocus", rawName: "v-autofocus" },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.errors.has("nombre") },
            attrs: { name: "nombre" },
            domProps: { value: _vm.model.nombre },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.submit()
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.model, "nombre", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm.errors.has("nombre")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("nombre"))),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-field",
        { attrs: { label: "Depende de" } },
        [
          _c(
            "b-select",
            {
              key: "lista-areas",
              attrs: { loading: _vm.isLoading, expanded: "" },
              model: {
                value: _vm.model.dependencia_id,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "dependencia_id", $$v)
                },
                expression: "model.dependencia_id",
              },
            },
            [
              _c("option", { domProps: { value: null } }, [
                _vm._v(_vm._s(_vm.isLoading ? "Espere un momento" : "Ninguna")),
              ]),
              _vm._v(" "),
              _vm._l(_vm.areas, function (opcion) {
                return _c(
                  "option",
                  { key: opcion.id, domProps: { value: opcion.id } },
                  [_vm._v(_vm._s(opcion.nombre))]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "field is-clearfix" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary is-pulled-right",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.submit()
              },
            },
          },
          [
            _c("i", { staticClass: "fas fa-save fa-fw" }),
            _vm._v("Guardar\n    "),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "Ingrese los datos del área a registrar para la organización. Una vez que finalizó de cargar los datos, presione el botón\n    "
        ),
        _c("span", { staticClass: "tag is-primary" }, [_vm._v("Guardar")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }